<app-review-section
  #deviceSection
  [title]="('drr-ccd-devices.information-on-ccd-header' | translate) + (subTitle && ' - ') + subTitle"
  class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
  [formGroup]="form"
  [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_Device"
  [applicationId]="applicationId"
  [entityId]="form?.value?.id"
  [deletable]="canBeDeleted"
  (delete)="removeDevice()"
  [isDetailsView]="isDetailsView">
  <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-12 ui-sm-12 ui-xs-12 form-container" *ngIf="controls.ccdType.visible">
    <!-- type-of-ccd -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
      <app-drop-down
        [label]="'drr-ccd-devices.type-of-ccd-lbl' | translate"
        [options]="typeofCcdOptions"
        [formControl]="form.controls.ccdType"
        [forceDisable]="!deviceSection.isDataEditable"></app-drop-down>
    </div>

    <!-- type-of-heating-pump -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.heatingPumpType.visible">
      <app-drop-down
        [label]="'drr-ccd-devices.type-of-heating-pump-lbl' | translate"
        [options]="typeofHeatingPump"
        [formControl]="form.controls.heatingPumpType"
        [forceDisable]="!deviceSection.isDataEditable"></app-drop-down>
    </div>

    <!-- airConditioningType -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.airConditioningType.visible">
      <app-drop-down
        [label]="'drr-ccd-devices.type-of-air-conditioning-lbl' | translate"
        [options]="airConditioningTypes"
        [formControl]="form.controls.airConditioningType"
        [forceDisable]="!deviceSection.isDataEditable"></app-drop-down>
    </div>

    <!-- wallBoxType -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.wallBoxType.visible">
      <app-drop-down
        [label]="'drr-ccd-devices.type-of-wall-box-lbl' | translate"
        [options]="wallBoxTypes"
        [formControl]="form.controls.wallBoxType"
        [forceDisable]="!deviceSection.isDataEditable"></app-drop-down>
    </div>

    <!-- other -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.other.visible">
      <app-input [formControl]="form.controls.other" [forceDisable]="!deviceSection.isDataEditable"></app-input>
    </div>

    <!-- total-grid-power-consumption -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.totalConsumption.visible">
      <app-input-number
        [label]="'drr-ccd-devices.total-grid-power-consumption-lbl' | translate"
        [formControl]="form.controls.totalConsumption"
        [forceDisable]="true"></app-input-number>
    </div>

    <!-- heat pump and air conditioning info text -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 info-rows" *ngIf="showBewareNoteforSeveralHeatPumpsOrAirConditioners">
      <app-note [header]="'beware' | translate">
        <span [innerHTML]="'drr-ccd-devices.heat-pump-conditioner-info-text' | translate"></span>
      </app-note>
      <app-note [header]="">
        <a [routerLink]="['/download-center']" target="_blank" [innerHTML]="'drr-ccd-devices.download-center-info-text' | translate"></a>
      </app-note>
    </div>

    <!-- wallbox info text -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 info-rows" *ngIf="showBewareNoteforWallbox">
      <app-note
        [header]="'beware' | translate"
        [content]="'drr-ccd-devices.regulation-according-to-section-35-st-vo-inf' | translate"></app-note>
      <app-note [header]="">
        <a
          [routerLink]="['/download-center']"
          target="_blank"
          [innerHTML]="'drr-ccd-devices.regulation-according-to-section-35-st-vo-notice' | translate"></a>
      </app-note>
    </div>

    <!-- storage info text -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 info-rows" *ngIf="showBewareNoteforStorage">
      <app-note [header]="'beware' | translate">
        <span [innerHTML]="'drr-ccd-devices.storage-grid-reference-power-inf' | translate"></span>
      </app-note>
      <app-note [header]="">
        <a
          [routerLink]="['/download-center']"
          target="_blank"
          [innerHTML]="'drr-ccd-devices.regulation-according-to-section-35-st-vo-notice' | translate"></a>
      </app-note>
      <app-note [header]="">
        <a
          [routerLink]="['/download-center']"
          target="_blank"
          [innerHTML]="'drr-ccd-devices.storage-grid-reference-power-notice' | translate"></a>
      </app-note>
    </div>

    <!-- typeOfControl -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.typeOfControl.visible">
      <app-radio-button-group
        [label]="'drr-ccd-devices.type-of-control-lbl' | translate"
        name="typeOfControl_ + {{ index }}"
        [options]="typeOfControlOptions"
        [formControl]="form.controls.typeOfControl"
        [forceDisable]="!deviceSection.isDataEditable"></app-radio-button-group>
    </div>

    <!-- module -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.module.visible">
      <app-drop-down
        [label]="'drr-ccd-devices.module-choice-lbl' | translate"
        [options]="moduleTypes"
        [formControl]="form.controls.module"
        [forceDisable]="!deviceSection.isDataEditable"></app-drop-down>
    </div>

    <!-- cascadeMeasurementDesired -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.cascadeMeasurementDesired.visible">
      <app-radio-button-yes-no
        [label]="'drr-ccd-devices.cascade-measurement-lbl' | translate"
        name="cascadeMeasurementDesired_ + {{ index }}"
        [formControl]="form.controls.cascadeMeasurementDesired"
        [style]="'horizontal'"
        [forceDisable]="!deviceSection.isDataEditable"></app-radio-button-yes-no>
    </div>

    <!-- separateMeterRequired -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.separateMeterRequired.visible">
      <app-radio-button-yes-no
        name="separateMeterRequired_ + {{ index }}"
        [label]="'drr-ccd-devices.separate-meter-required-lbl' | translate"
        [formControl]="form.controls.separateMeterRequired"
        [forceDisable]="!deviceSection.isDataEditable"
        [style]="'horizontal'"></app-radio-button-yes-no>
    </div>

    <!-- meterNumber -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.meterNumber.visible">
      <app-input
        [label]="'drr-ccd-devices.meter-number-of-ccd-lbl' | translate"
        [formControl]="form.controls.meterNumber"
        [forceDisable]="!deviceSection.isDataEditable"></app-input>
    </div>

    <!-- meter2 -->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.meter2.visible">
      <app-input
        [label]="'drr-ccd-devices.meter-2-lbl' | translate"
        [formControl]="form.controls.meter2"
        [forceDisable]="!deviceSection.isDataEditable"></app-input>
    </div>
  </div>
  <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.schemaImage.visible" [@addRemoveAnimation]>
    <img src="assets/images/drr-ccd-devices/heating-pump-en.png" alt="Heating Pump" />
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="controls.ccdType.visible">
    <app-drr-ccd-device-units
      (formInited)="initDeviceUnits($event)"
      [ccdType]="form.get('ccdType').value"
      [data]="data?.deviceUnits?.units"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView"
      [allowAddSubUnit]="deviceSection.isDataEditable"
      [allowAddUnit]="deviceSection.isDataEditable"></app-drr-ccd-device-units>
  </div>
</app-review-section>
